import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { MdSearch, MdLocationCity } from "react-icons/md";

const routeStates = [
  "Karnataka",
  "Assam",
  "Kerala",
  "Punjab",
  "Orissa",
  "Delhi",
  "Bihar",
  "Chattisgarh",
  "Jharkhand",
  "Goa",
  "Gujarat",
  "Maharashtra",
  "Meghalaya",
  "Mizoram",
  "Rajasthan",
  "Sikkim",
  "Telangana",
  "Uttarakhand",
  "Uttar Pradesh",
  "Madhya Pradesh",
  "Arunachal Pradesh",
  "Andhra Pradesh",
  "Tamil Nadu",
  "West Bengal",
];



const CollegeList = () => {
  const base_url = import.meta.env.VITE_API_BASE_URL;

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stateOptions = routeStates.map((state) => ({
      value: state,
      label: state,
      count: 0,
    }));

    setStates(stateOptions);
  }, []);
  const [page, setPage] = useState(1);
  const limit = 20;

  useEffect(() => {
    fetchColleges();
  }, [selectedState]);

  const fetchColleges = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`https://backend-mbbs.onrender.com/api/state/${selectedState?.value}`);
      console.log('res', res)
      const colleges = res.data || [];

      setData(colleges);
      setFilteredData(colleges);

      const stateOptions = routeStates.map((state) => ({
        value: state,
        label: state,
        count: colleges.filter(
          (item) =>
            item.state &&
            item.state.toLowerCase() === state.toLowerCase()
        ).length,
      }));

      setStates(stateOptions);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let filtered = [...data];

    if (selectedState) {
      filtered = filtered.filter(
        (item) =>
          item.state &&
          item.state.toLowerCase() ===
          selectedState.value.toLowerCase()
      );
    }

    if (searchTerm) {
      filtered = filtered.filter(
        (item) =>
          item.collegename
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.city
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
    }

    setFilteredData(filtered);
    setPage(1);
  }, [selectedState, searchTerm, data]);

  const totalPages = Math.ceil(filteredData.length / limit);

  const paginatedData = filteredData.slice(
    (page - 1) * limit,
    page * limit
  );

  return (
    <div className="page-wrapper">
      <div className="container-fluid mt-3">
        <div className="card shadow border-0">

          <div className="card-header bg-white">
            <div className="row align-items-center">

              <div className="col-md-3">
                <h4 className="fw-bold mb-0">
                  <MdLocationCity className="me-2 text-primary" />
                  Colleges
                </h4>
              </div>

              <div className="col-md-4">
                <div className="input-group">
                  <span className="input-group-text">
                    <MdSearch />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search College..."
                    value={searchTerm}
                    onChange={(e) =>
                      setSearchTerm(e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="col-md-5">
                <Select
                  options={routeStates.map((state) => ({
                    value: state,
                    label: state,
                  }))}
                  value={selectedState}
                  onChange={setSelectedState}
                  isClearable
                  placeholder="Select State"
                />
              </div>

            </div>
          </div>

          <div className="card-body">

            <div className="mb-3 d-flex flex-wrap gap-2">
              <button
                className={`btn btn-sm ${!selectedState
                  ? "btn-primary"
                  : "btn-outline-primary"
                  }`}
                onClick={() => setSelectedState(null)}
              >
                All ({data.length})
              </button>

            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover">

                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>College</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Type</th>
                    <th>Established</th>
                    <th>Fees</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                      </tr>
                    ))
                  ) : paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <tr key={item.id}>
                        <td>
                          {(page - 1) * limit + index + 1}
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            {item.image1 && (
                              <img
                                src={item.image1}
                                alt=""
                                className="rounded-circle me-2"
                                width="40"
                                height="40"
                              />
                            )}
                            <strong>
                              {item.collegename}
                            </strong>
                          </div>
                        </td>

                        <td>
                          <span className="badge bg-primary">
                            {item.state}
                          </span>
                        </td>

                        <td>{item.city || "-"}</td>

                        <td>
                          {item.collegetype || "-"}
                        </td>

                        <td>
                          {item.established || "-"}
                        </td>

                        <td>{item.fees || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="7"
                        className="text-center py-4"
                      >
                        No Colleges Found
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end gap-2">

                <button
                  className="btn btn-outline-secondary btn-sm"
                  disabled={page === 1}
                  onClick={() =>
                    setPage(page - 1)
                  }
                >
                  Previous
                </button>

                <span className="align-self-center">
                  Page {page} of {totalPages}
                </span>

                <button
                  className="btn btn-outline-secondary btn-sm"
                  disabled={page === totalPages}
                  onClick={() =>
                    setPage(page + 1)
                  }
                >
                  Next
                </button>

              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default CollegeList;